import { Translate } from '@chipinside/translate'
import { Divider } from '@mui/material'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { endpoint } from '#/store/services/endpoints'
import { subscribe } from '#/utils/pubsub'

import FormatAlert from '../Manipulate/FormatAlert'

export default function AnimalSystemTab(props) {
  const history = useHistory()
  const { farm, setIsOpen, type, setShowSnack, setNewMessage, timestamp } = props

  useEffect(() => {
    const firebase = subscribe('firebase-alert-arrived', props => {
      const { alertable_slug, message } = props
      if (alertable_slug === farm) {
        if (message) {
          setNewMessage(message)
          setShowSnack(true)
        }
      }
    })
    return () => {
      firebase.unsubscribe()
    }
  }, [farm])

  const GetType = type => ({
    key: type,
    endpoint: endpoint.notifications.alerts({ farm }),
    filters: [{ name: 'alert_type', value: type }],
    timestamp,
    content: (
      <React.Fragment key={`notification-tab-${type}-content`}>
        <Divider />
        <FormatAlert {...props} />
      </React.Fragment>
    ),
    footer: [
      {
        text: Translate({ messageKey: 'view_all_notifications' }),
        onClick: () => {
          setIsOpen(false)
          history.push(`/farm/${farm}/modules/notifications`)
        },
      },
    ],
  })

  return GetType(type)
}
